<template>
    <div>
       
        <div class="row">
            <div class="col-8">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                        Statement of supplier: {{ creditorName }}

                    </span>
                </div>
            </div>
            <div class="col-4 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <!--<span style="margin-right:5px">Add New Unit</span>
            <router-link class="btn btn-table" :to="{
      name: 'property',
      params: { buildingId: buildingId, buildingName: buildingName },
    }"><i class="fas fa-plus"></i></router-link>-->
                    <span @click="exportToPDF()"
                          style="
width: 30px;
height: 30px;
border-radius: 5px;
background-color: #007DFC;
color: white;
display: inline-block;
padding-left: 5px;
padding-right: 5px;
text-align: center;
cursor:pointer;
margin-left:5px;
">
                        <i class="fa fa-file-export" style="margin-top:7px;" aria-hidden="true"></i>
                    </span>
                    <userMenu />
                </div>
            </div>

        </div>



        <div class="row">
            <div class="pull-left col-12 col-md-3 col-sm-6"
                 style="margin-bottom: 10px;">
                <label>Date From:</label>
                <date-picker :format="customFormatter"
                             v-model="fromDate"
                             style="border: 1px solid grey;text-align:center" />
            </div>

            <div class="col-12 col-md-3 col-sm-6">
                <label>Date To:</label>
                <date-picker  :format="customFormatter"
                             v-model="toDate"
                             style="border: 1px solid grey;text-align:center" />
            </div>

            <div class="col-1 col-md-1 col-sm-1 text-right">
                <button class="btn btn-primary" v-on:click="fetchStatement">
                    <div class="board-add">Search</div>
                </button>
            </div>
        </div>

        <div class="table-responsive" id="creditor-admin">
            <table class="table table-condensed">
                <thead>
                    <tr>
                        <th scope="col">No</th>
                        <th scope="col">Date</th>
                        <th scope="col">Invoice No.</th>
                        <th scope="col">Expense Type</th>
                        <th scope="col">Vat%</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Net Amount</th>
                        <th scope="col">Vat Amount</th>
                        <th scope="col">Payment</th>
                        <th scope="col">Credit Note</th>
                        <th scope="col">Amount Due</th>
                        <th scope="col">Payments</th>
                        <!--  <th class="text-center" colspan="2">Actions</th>-->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(expense, key, index) in additionalExpenses"
                        :key="index"
                        class="clickable-row">
                        <td scope="row">{{ ++key }}</td>
                        <td>{{ customFormatterISO(expense.expenseDate) }}</td>
                        <td>{{ expense.invoiceNo }}</td>
                        <td>{{ expense.expenseName }}</td>
                        <td>{{ $filters.toCurrency(expense.vatPercentage) }}</td>
                        <td>{{ $filters.currency(expense.amountOfExpense, "€") }}</td>
                        <td>{{ $filters.currency(expense.netAmountOfExpense, "€") }}</td>
                        <td>{{ $filters.currency(expense.vatAmountOfExpense, "€") }}</td>
                        <td>{{ $filters.currency(expense.amountPaid, "€") }}</td>
                        <td>{{ $filters.currency(expense.amountReturned, "€") }}</td>
                        <td>
                            {{ $filters.currency((expense.amountOfExpense - expense.amountPaid- expense.amountReturned), "€") }}
                        </td>
                        <td style="text-align:right;">

                            <router-link style="display: inline-block; margin-left: 6px;" class="btn btn-table" :to="{
                    name: 'creditorpaymentstatement',
                    params: {
                      buildingId: buildingId,
                      creditorId: creditorId,
                      payments: expense.payments,
                      returns: expense.returns,
                      expenseId: expense.expenseId
                    },
                  }"><i class="fas fa-receipt"></i></router-link>
                        </td>

                        <!-- <td style="width:10%">
        <a class="btn btn-edit" style="width:90px;" @click.prevent="editItem(expense)">Edit</a>
    </td>
    <td style="width:10%">
        <a class="btn btn-delete" style="width:90px;" @click.prevent="deleteItem(expense)">Delete</a>
    </td>-->
                    </tr>
                    <tr style="color: black; font-size: 1.11em;">
                        <td scope="row" class="text-center"></td>

                        <td class="text-center"></td>
                        <td class="text-center"></td>
                        <td class="text-center"></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="text-right">
                            <strong>Total Due :</strong>
                        </td>
                        <td class="text-left">
                            <strong>{{ $filters.currency(totalAmount, "€") }} </strong>
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row" style="margin-top:30px;">
        <div class="col-12">
            <a @click="$router.go(-1)" class="btn btn-cancel" style="width:60px; display: block; margin-left: auto; margin-right: 0; margin-top: -30px">Back</a>
        </div>
    </div>
    </div>
</template>
<script>
import { format, parseISO } from "date-fns";
import { mapState } from "vuex";
import html2pdf from "html2pdf.js"
export default {
  data: function () {
    return {
      filter: "",
      additionalExpenses: [],
      buildingId: 0,
     // buildingName: "",
      creditorId: 0,
      creditorName: "",
      totalAmount: 0,
      fromDate: new Date(new Date().getFullYear() - 1, 0, 1),
      toDate: new Date(),
    };
  },
  mounted() {
    this.buildingId = this.$route.params.buildingId;
 //   this.buildingName = this.$route.params.buildingName;
    this.creditorId = this.$route.params.creditorId;
    this.creditorName = this.$route.params.creditorName;
    //this.buildingName = this.$route.params.buildingName;
    this.fetchStatement();
  },
  computed: {
    getCreditorExpenses() {
      var committees = this.additionalExpenses.filter((supplier) => {
        console.log(supplier);
        return supplier.expenseName.toLowerCase();
      });
      console.log(committees);
      return committees;
    },
  },
  computed:{
  ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
  },
  methods: {
    fetchStatement: function () {
      this.mute = true;
      //this.buildingId = 3;
      var request = "/expensepayments/provider";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      // console.log(this.toDate)
      console.log(parseISO(format(this.toDate, "yyyy-MM-dd")));

      this.$http
        .post("/expensepayments/provider", {
          buildingId: this.buildingId,
          creditorId: this.creditorId,
          fromDate: parseISO(this.sendDateFormat(this.fromDate)),
          toDate: parseISO(this.sendDateFormat(this.toDate)),
        })
        .then((response) => {
          this.mute = false;
          console.log(response);
          //this.contacts = data.contacts;
          this.additionalExpenses = response.data.expensePayments;
          this.totalAmount = response.data.totalAmount;
        });

      /* this.$http.get(request, {
                        id : this.buildingId
                    }).then(({data}) => {
                                this.mute = false;
                                //this.contacts = data.contacts;
                            this.additionalExpenses = data.expensePayments;
                            console.log(this.additionalExpenses);*/
    },
        exportToPDF() {
    html2pdf(document.getElementById("creditor-admin"), {
        margin: 1,
        filename: "creditor-statement.pdf",
        html2canvas: { scale: 2 },
        enableLinks: false,
        jsPDF: { orientation: 'landscape' }
    });
},
    editItem: function (item) {
      this.$router.push({
        name: "additionaldetail",
        params: {
          expenseId: item.id,
          buildingId: this.buildingId,
          buildingName: this.buildingName,
        },
      });
    },
    deleteItem: function destroy(item) {
      var r = confirm("Are you sure you want to delete additional expense?");
      if (r == true) {
        var _this = this;
        this.axios.delete("/additionalexpenses/" + item.id).then(function () {
          _this.fetchStatement();
          // _this.getVueItems();
          //_this.hasDeleted = false
        });
      }
    },
    customFormatter(date) {
      return format(date, "dd/MM/yyyy");
    },
    customFormatterISO(date) {
      return format(parseISO(date), "dd/MM/yyyy");
    },
    sendDateFormat(date) {
      return format(date, "yyyy-MM-dd");
    },
  },
};
</script>
